import { Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IconService, cachedIcons } from './icon.service';
import { IconSize } from './icon-interface';

@Component({
  selector: 'opac-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  providers: [IconService]
})
export class IconComponent implements OnInit, OnChanges {
  private static readonly SIZE_MAPPER = {
    ['0.75x']: '18',
    ['1x']: '24',
    ['1.5x']: '36',
    ['2x']: '48',
    ['2.5x']: '64',
    ['4x']: '96',
  } as const;

  private completeName: string = '';

  @HostBinding('class.has-badge') get hasBadge() {
    return this.badge;
  }

  @HostBinding('style.--icon-clip-path-name') get iconClipPathNameVariable() {
    return `url(#${this.icon}NotificationMask)`;
  }

  /**
   * Determines if aria-hidden attr should be applied. Defaults to `false`
   */
  @Input() ariaHidden: boolean = true;
  /**
   * Represents whether a badge marker should be visible or not.
   */
  @Input() badge: boolean = false;
  /**
   * Sets the icon name
   */
  @Input() icon: string = '';
  /**
   * Sets the icon size. Defaults to `1x`
   */
  @Input() size: IconSize = '1x';

  iconSvg: string = '';

  constructor(
    private readonly iconService: IconService,
  ) {
  }

  ngOnInit() {
    this.completeName = `i_${this.icon}_${IconComponent.SIZE_MAPPER[this.size]}`;
    this.loadIcon(this.completeName);
  }

  ngOnChanges(changes: SimpleChanges) {
    const iconName = changes.icon?.currentValue ?? this.icon;
    const iconSize = changes.size?.currentValue ?? this.size;

    if (changes.icon || changes.size) {
      this.completeName = `i_${iconName}_${IconComponent.SIZE_MAPPER[iconSize]}`;
      this.loadIcon(this.completeName);
    }
  }

  private loadIcon(icon: string) {
    if (cachedIcons.has(icon)) {
      if (icon === this.completeName) {
        this.iconSvg = cachedIcons.get(icon);
      }
    } else {
      this.iconService.getIcon(icon).then(() => {
        if (icon === this.completeName) {
            this.iconSvg = cachedIcons.get(icon);
          }
      });
    }
  }
}
